import script from "./ViewLogs.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLogs.vue?vue&type=script&setup=true&lang=js"

import "./ViewLogs.vue?vue&type=style&index=0&id=0f1026c0&scoped=true&lang=css"
import "./ViewLogs.vue?vue&type=style&index=1&id=0f1026c0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f1026c0"]])

export default __exports__